import { applyVAT } from '../../utils/string';

const selectAnalytics = (items, setup, currentView, itemIndex) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	window.dataLayer.push({
		event: 'select_item',
		ecommerce: {
			items: items.map((item) => {
				const itemCategory = item.canonicalUri.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
				return {
					item_name: item.name,
					item_id: item.variantId,
					price: applyVAT(setup, item.price, false, 5),
					item_brand: item.brand,
					...itemCategory,
					item_variant: item.variant,
					item_list_name: currentView,
					index: itemIndex,
					quantity: '1',
				};
			}),
		},
	});
};

export default selectAnalytics;
